import { SearchMapState } from './searchMap.types'

export const SearchMapInitialState: SearchMapState = {
  isMouseOverPopup: false,
  points: [],
  bounds: null,
  center: { lat: 39.5, lng: -101 },
  zoom: 5,
  size: {
    width: 0,
    height: 0,
  },
  popup: null,
}
